import { Flashcard, FlashcardType } from "../types";

export const parseAIResponse = (rawInput: string): Flashcard[] => {
  try {
    const match = rawInput.match(/\[[\s\S]*\]/);

    if (!match) {
      throw new Error(
        "No JSON found. Did you copy the full output starting with '['?"
      );
    }

    const jsonString = match[0];
    const parsed = JSON.parse(jsonString);

    if (!Array.isArray(parsed)) {
      throw new Error("The AI output is not a list (Array).");
    }

    return parsed.map((item: any, index: number) => {
      // Validate Type safely
      const validTypes: FlashcardType[] = ["basic", "mcq", "concept", "cloze", "application"];
      const cardType: FlashcardType = validTypes.includes(item.type) ? item.type : "basic";

      return {
        id: `card-${Date.now()}-${index}`,
        // FIXED: Add required status field
        status: "new",
        type: cardType,
        front: item.front || "Missing Question",
        back: item.back || "Missing Answer",
        options: item.options || undefined,
        correctAnswer: item.correctAnswer || undefined,
        // Removed 'topic' as it is not in Flashcard interface
        tags: item.tags || ["General"],
        sourceUrl: item.sourceUrl
      };
    });
  } catch (error) {
    console.error("Sanitizer Error:", error);
    throw error;
  }
};